import { wrapPageElement } from './gatsby-ssr';

export { wrapPageElement };

export const onServiceWorkerUpdateReady = () => window.location.reload(true);
